export interface IDispatchByStatus {
  readonly id: number;
  readonly name: string;
  readonly total: number;
}

export interface IDeviceByStatus {
  readonly id: number;
  readonly name: string;
  readonly total: number;
}

export interface IDispatchByType {
  readonly name: string;
  readonly code: string;
  readonly total: number;
}

export interface IDispatchByTypeSubtype {
  readonly name: string;
  readonly type_code: string;
  readonly subtype_code: string;
  readonly total: number;
}

export interface IDispatchByClosedStatus {
  readonly name: string;
  readonly total: number;
}

export interface IDispatchByDispatchGroup {
  readonly id: number;
  readonly name: string;
  readonly total: number;
}

export interface IDispatchByCity {
  readonly name: string;
  readonly total: number;
}

export interface IDispatchByDistrict {
  readonly name: string;
  readonly total: number;
}

export interface IDispatchByDevice {
  readonly id: number;
  readonly name: string;
  readonly total: number;
}

export interface IDispatchesByHours {
  readonly hour: number;
  readonly range: string;
  readonly total: number;
}

export interface IDispatchesByWeekday {
  readonly weekday: string;
  readonly total: number;
}

export interface IStatisticsFilters {
  readonly agencyId?: number;
  readonly dispatchGroupIds?: readonly number[];
  readonly typeIds?: readonly number[];
  readonly subtypeIds?: readonly number[];
  readonly areaId?: number;
  readonly closedStatusId?: number;
  readonly startDate: string;
  readonly finishDate?: string;
  readonly startTime?: string | null;
  readonly endTime?: string | null;
}

export interface IExportDispatchesFilters {
  readonly startDate: string;
  readonly finishDate?: string | Date;
  readonly excludeClosed?: boolean;
  readonly agencyId?: number;
  readonly dispatchGroupIds?: readonly number[];
  readonly typeIds?: readonly number[];
  readonly subtypeIds?: readonly number[];
  readonly categoryIds?: readonly number[];
  readonly operationId?: number;
  readonly withSolvedThirdParty?: boolean;
  readonly coordinationId?: number;
  readonly deviceId?: number;
  readonly consummated?: boolean | null;
  readonly statusIds?: readonly number[];
  readonly cityIds?: readonly number[];
  readonly groupSetId?: number;
  readonly location?: string;
  readonly closedStatusClassId?: number;
  readonly closedStatusId?: number;
  readonly qualifierOptions?: readonly number[];
  readonly operationUnitId?: number;
  readonly name?: string;
  readonly phone?: string;
  readonly userId?: number;
  readonly geographicAreas?: readonly any[];
  readonly districtIds?: readonly number[];
  readonly typeFile: 'kml' | 'geojson' | 'csv' | 'xml';
}

export enum DataCombinationType {
  DISPATCH_BY_STATUS = 'dispatch-by-status',
  DEVICE_BY_STATUS = 'device-by-status',
  DISPATCH_BY_TYPE = 'dispatch-by-type',
  DISPATCH_BY_SUBTYPE = 'dispatch-by-type-subtype',
  DISPATCH_BY_CLOSED_STATUS = 'dispatch-by-closed-status',
  DISPATCH_BY_DISPATCH_GROUP = 'dispatch-by-dispatch-group',
  DISPATCH_BY_CITY = 'dispatch-by-city',
  DISPATCH_BY_DISTRICT = 'dispatch-by-district',
  DISPATCH_BY_DEVICE = 'dispatch-by-device',
  DISPATCHES_BY_HOURS = 'dispatches-by-hours',
  DISPATCHES_BY_WEEKDAY = 'dispatches-by-weekday',
}

export enum ChartType {
  NUMERIC = 'numeric',
  BAR = 'bar',
  COLUMN = 'column',
  PIE = 'pie',
  LINE = 'line',
}

export interface IChartConfig {
  readonly id: string;
  readonly dataCombination: DataCombinationType;
  readonly chartType: ChartType;
  readonly filters: IStatisticsFilters;
  readonly position?: number;
}

export type StatisticsDataType =
  | readonly IDispatchByStatus[]
  | readonly IDeviceByStatus[]
  | readonly IDispatchByType[]
  | readonly IDispatchByTypeSubtype[]
  | readonly IDispatchByClosedStatus[]
  | readonly IDispatchByDispatchGroup[]
  | readonly IDispatchByCity[]
  | readonly IDispatchByDistrict[]
  | readonly IDispatchByDevice[]
  | readonly IDispatchesByHours[]
  | readonly IDispatchesByWeekday[];
